var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 49 48",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EFE54E",
  d: "M48.889 24l-8.698 3.623 6.28 7.06-9.399-.548 2.616 9.106-8.238-4.587L29.882 48l-5.438-7.741L19.007 48l-1.568-9.346-8.238 4.587 2.616-9.106-9.399.548 6.28-7.06L0 24l8.698-3.623-6.28-7.06 9.399.548-2.615-9.106 8.237 4.587L19.007 0l5.437 7.741L29.882 0l1.568 9.346 8.238-4.587-2.616 9.106 9.399-.548-6.28 7.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EFE54E",
  d: "M37.623 24c0 7.328-5.9 13.269-13.178 13.269-7.279 0-13.18-5.94-13.18-13.269 0-7.328 5.901-13.27 13.18-13.27 7.278 0 13.178 5.942 13.178 13.27"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 0.75,
  d: "M37.623 24c0 7.328-5.9 13.269-13.178 13.269-7.279 0-13.18-5.94-13.18-13.269 0-7.328 5.901-13.27 13.18-13.27 7.278 0 13.178 5.942 13.178 13.27z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sun.b5f43a5e6576e168fbf2b0da69b9cc2a.svg";